import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';

import { ClientInvitation, ClientInvitationStatus, GetClientInvitationComponent } from 'api/public';
import { QueryManager } from 'components';
import { login, signUp } from 'paths';

import { TOKEN_PARAM } from 'features/auth/constants';

interface IProps {
  children: (props?: ClientInvitation) => JSX.Element;
}

const GetClientInvitation: FC<IProps> = ({ children }) => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get(TOKEN_PARAM);

  if (!token) {
    return children();
  }

  return (
    <GetClientInvitationComponent variables={{ id: token }}>
      {queryResult => (
        <QueryManager loader="standard" {...queryResult}>
          {({ data }) => {
            if (!data || !data.getClientInvitation) {
              return <Redirect to={signUp} />;
            }

            const { getClientInvitation } = data;
            const isAccepted =
              getClientInvitation.invitation_status === ClientInvitationStatus.Accepted;

            if (isAccepted) {
              return <Redirect to={login} />;
            }

            return children(getClientInvitation);
          }}
        </QueryManager>
      )}
    </GetClientInvitationComponent>
  );
};

export default GetClientInvitation;
